import { ChangeDetectionStrategy, Component, Inject, inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { AsyncPipe } from '@angular/common';
import { DataSourceDirective } from 'eurogard-data-source/directive';
import { DataSourceErrorComponent } from 'eurogard-data-source';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelContent,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatProgressBar } from '@angular/material/progress-bar';
import { PersistentAccordionDirective } from '@rxap/material-directives/expansion';
import {
  AlarmingSettingsPanelComponent
} from 'angular-components/alarming-settings-panel/alarming-settings-panel.component';
import {
  SubscribedMachinesPanelComponent
} from 'angular-components/subscribed-machines-panel/subscribed-machines-panel.component';
import {
  UserSettingsAccordionDataSource
} from 'angular-components/layout/default-header/user-profile-icon/user-settings/user-settings-accordion.data-source';
import { ACCORDION_DATA_SOURCE } from 'eurogard-data-source/accordion';
import { MatListModule } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import {
  SetUserPasswordDialogComponent
} from 'angular-components/set-user-password-dialog/set-user-password-dialog.component';
import {
  DataGridCellDefDirective,
  DataGridComponent, DataGridEditCellDefDirective,
  DataGridHeaderCellDefDirective,
  DataGridRowDefDirective,
} from 'eurogard-data-grid';
import { FormDirective } from 'eurogard-forms';
import { ReactiveFormsModule } from '@angular/forms';
import { FormProviders, FormComponentProviders } from './form.providers';
import { UserInfoDataSource } from './user-info.data-source';
import {
  CompareWithDirective,
  ControlErrorDirective,
  InputClearButtonDirective,
  RequiredDirective,
} from 'eurogard-material-form-system';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatOption } from '@angular/material/autocomplete';
import { StopPropagationDirective } from '@rxap/directives';
import { InputSelectOptionsDirective } from 'eurogard-form-system';
import { MatSelect } from '@angular/material/select';
import { UserMfaSettingsComponent } from 'angular-components/user-mfa-settings/user-mfa-settings.component';
import { FeatureInfoTextComponent } from 'angular-components/feature-info';
import { AuthorizationService, RXAP_AUTHORIZATION_SCOPE } from '@rxap/authorization';
import {
  RegistrationTokenFormComponent
} from 'angular-components/registration-token-form/registration-token-form.component';

@Component({
  selector: 'eurogard-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: [ './user-settings.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    AsyncPipe,
    DataSourceDirective,
    DataSourceErrorComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelContent,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatProgressBar,
    PersistentAccordionDirective,
    AlarmingSettingsPanelComponent,
    SubscribedMachinesPanelComponent,
    MatListModule,
    MatIcon,
    DataGridComponent,
    DataGridCellDefDirective,
    DataGridRowDefDirective,
    DataGridHeaderCellDefDirective,
    FormDirective,
    ReactiveFormsModule,
    DataGridEditCellDefDirective,
    InputClearButtonDirective,
    MatFormField,
    MatInput,
    MatLabel,
    MatSuffix,
    ControlErrorDirective,
    MatError,
    RequiredDirective,
    MatOption,
    StopPropagationDirective,
    CompareWithDirective,
    InputSelectOptionsDirective,
    MatSelect,
    UserMfaSettingsComponent,
    FeatureInfoTextComponent,
    RegistrationTokenFormComponent,
  ],
  providers: [
    UserSettingsAccordionDataSource,
    UserInfoDataSource,
    {
      provide: ACCORDION_DATA_SOURCE,
      useExisting: UserSettingsAccordionDataSource,
    },
    FormProviders,
    FormComponentProviders,
  ],
})
export class UserSettingsComponent {
  public readonly accordionDataSource = inject(UserSettingsAccordionDataSource);
  protected readonly userInfoDataSource = inject(UserInfoDataSource);
  private readonly dialog = inject(MatDialog);

  protected readonly hasPermissionDeviceInboxToken: boolean;

  constructor(
    @Inject(AuthorizationService)
    private readonly authorization: AuthorizationService,
    @Optional()
    @Inject(RXAP_AUTHORIZATION_SCOPE)
    private readonly scope: string | null = null,
  ) {
    this.hasPermissionDeviceInboxToken = this.authorization.hasPermission('thing.create', this.scope);
  }

  public openResetPasswordDialog() {
    this.dialog.open(SetUserPasswordDialogComponent, {
      data: { __rowId: this.accordionDataSource.user()?.uuid },
    });
  }

}
